import {
  action,
  computed,
  makeObservable,
  observable,
  runInAction
} from 'mobx';

interface TimerStoreProps {
  delay: number; // in ms
}
export class TimerStore {
  private delay: number; // in ms
  _elapsedTime: number = 0; // in ms
  _tmpElapsed: number = 0; // in ms
  private timeout?: number;
  finished: boolean = false;
  private startTimeout?: number;

  constructor({ delay }: TimerStoreProps) {
    this.delay = delay;
    makeObservable(this, {
      resume: action,
      pause: action,
      finished: observable,
      _elapsedTime: observable,
      _tmpElapsed: observable,
      isFinished: computed,
      elapsedTime: computed,
      tick: computed
    });
  }

  pause() {
    clearTimeout(this.timeout);
    this._elapsedTime += this.startTimeout ? Date.now() - this.startTimeout : 0;
    this.startTimeout = undefined;
  }

  resume() {
    if (this.delay !== null && this.delay !== undefined && !this.finished) {
      this.timeout = (setTimeout(() => {
        runInAction(() => {
          this.finished = true;
        });
      }, this.delay - this._elapsedTime) as unknown) as number;
      this.startTimeout = Date.now();
    }
  }

  finish() {
    runInAction(() => {
      this.pause();
      this.finished = true;
    });
  }

  get isPaused(): boolean {
    return this.startTimeout === undefined;
  }

  get isFinished(): boolean {
    return this.finished;
  }

  get elapsedTime(): number {
    return this._elapsedTime;
  }

  get tick(): number {
    if (this._elapsedTime === 0) {
      this._tmpElapsed = this.startTimeout ? Date.now() - this.startTimeout : 0;
    } else {
      this._tmpElapsed = this.startTimeout
        ? Date.now() - (this.startTimeout - this._elapsedTime)
        : 0;
    }
    return Math.round((this.delay - this._tmpElapsed) / 1000);
  }
}
